
import * as BsIcons from "react-icons/bs";
import * as FaIcons from "react-icons/fa";
import { IMediaC } from "../../../context/types";
import { CSSProperties } from "react";
import { getDataObjArray } from "../Sidebar/SideBarUtils";
import i18n from "../../../i18n";




export function getDateForChangeMinute(DateSplit: string): Date {
  let date = new Date();
  if (DateSplit.includes("T")) {
    date.setHours(
      parseInt(DateSplit.split("T")[1].split(":")[0]),
      parseInt(DateSplit.split("T")[1].split(":")[1])
    );
  } else {
    date.setHours(
      parseInt(DateSplit.split(":")[0]),
      parseInt(DateSplit.split(":")[1])
    );
  }
  return date;
}


export function getLabelHourMC(

  HoraIni: any,
  HoraFin: any
): React.ReactNode {
  return HoraIni + " - " + HoraFin;
}

export function renderFaIconsCalendar() {
  return (<FaIcons.FaRegCalendarAlt />);
}

export function renderFaIconCheckCircle() {
  return <BsIcons.BsCheckCircle />;
}

export function renderFaIconPlusCircle() {
  return <BsIcons.BsPlusCircle />;
}

export function renderFaIconsCheckPlus(autoupdate: boolean) {
  if (autoupdate) {
    return renderFaIconCheckCircle();
  }
  return renderFaIconPlusCircle();
}

export function getClassNameMCNav(
  sidebar: string,
  valueCondition: string
): string {
  return sidebar === valueCondition ? "nav-menu-mc" : "nav-menu-mc-hidden";
}



export function formatDate(strData) {
  let dtData = new Date(strData);


  if (i18n?.language?.toUpperCase() != "EN-US") {
    return (
      dtData.getDate().toString().padStart(2, "0") + "-" +
      (dtData.getMonth() + 1).toString().padStart(2, "0") + "-" +
      dtData.getFullYear().toString()
    );
  }
  else {
    return (
      (dtData.getMonth() + 1).toString().padStart(2, "0") + "-" +
      dtData.getDate().toString().padStart(2, "0") + "-" +
      dtData.getFullYear().toString()
    );
  }
}


export function setMediaCompLocalStorage(MCPreference: any) {
  let userLocalStorage: IMediaC = {}
  userLocalStorage = {

    indice: MCPreference.indice,
    codIndice: MCPreference.codIndice,
    data: MCPreference.data ?? MCPreference.dataRating,
    minutos: MCPreference.minutos.replaceAll(" ", ""),
    autoUpdate: MCPreference.autoUpdate ?? true
  }

  localStorage.setItem('MCPreference', JSON.stringify(userLocalStorage));
}

export function setMediaCompLocalStorageAuOn(MCPreference: any, indiceNull: boolean) {
  let userLocalStorage: IMediaC = {}
  userLocalStorage = {

    indice: !indiceNull ? MCPreference.indice : '',
    codIndice: !indiceNull ? MCPreference.codIndice : '',
    data: MCPreference.data ?? MCPreference.dataRating,
    minutos: MCPreference.minutos.replaceAll(" ", ""),
    autoUpdate: MCPreference.autoUpdate ?? true
  }

  localStorage.setItem('MCPreference', JSON.stringify(userLocalStorage));
}

export function getMediaCompLocalStorage() {
  const json = localStorage.getItem('MCPreference');
  if (!json) return null;
  const user: IMediaC = JSON.parse(json);
  return user;
}
export function cleanMediaCompLocalStorage() {
  localStorage.removeItem('MCPreference');
}

export function setintervalAutoUpdateMCLocalStorage(value: string) {
  localStorage.setItem('intervalAutoUpdateMC', value);
}
export function getintervalAutoUpdateMCLocalStorage() {
  const result = localStorage.getItem('intervalAutoUpdateMC');
  if (!result) return null;
  return result;
}
export function cleanintervalAutoUpdateMCLocalStorage() {
  localStorage.removeItem('intervalAutoUpdateMC');
}


export function renderTableFirstGrid(row: any, rowContent, Target) {
  if (rowContent[2] === "") {
    return getDataObjArray(row).map((val, rowID) =>
      renderTableFirstGridRowContent2EmptyAndEqual1(val, rowID)
    );
  } else {
    return getDataObjArray(row).map((val, rowID) =>
      renderTableFirstGridEqual1or2(val, rowID, Target)
    );
  }
}

export function renderTableFirstGridRowContent2EmptyAndEqual1(val, rowID) {
  if (rowID === 1) {
    return (
      <>
        <td style={{ color: "rgb(201, 164, 4)", textAlign: "center" }} key={val.ValueId}>
          <i className="header-icon-13" style={{ fontSize: "12px" }}></i>
          {val.DataValueArray}
        </td>
        <td>

        </td>
      </>
    );
  }
  return <></>;
}

export function renderTableFirstGridEqual1or2(rowVal: any, rowID, Target) {
  if (rowID === 1)
    return (
      <td style={{ color: "white", textAlign: "center" }} key={rowVal.ValueId}>
        {rowVal.DataValueArray}
      </td>
    );

  if (rowID === 2)
    return (
      <td className="tableFirstGrid">
        <p style={{ margin: "0px" }}>
          <i
            className={"header-icon-" + Target}
            style={{ fontSize: "12px" }}
          ></i>
          <span style={{ color: "white" }}>{rowVal.DataValueArray}</span>
        </p>
      </td>
    );

  return <></>;
}
export function getCSSPropertiesHeight(
  userPreferenceTipoBase: number,
  Indice: number
) {
  const resultCss: CSSProperties = {
    height: userPreferenceTipoBase === 0 && Indice <= 2 ? "30px" : "48px",
  };
  return resultCss;
}
export function getStyleByIndice(Indice: any): CSSProperties | undefined {
  if (Indice > 2) {
    return { height: "48px" };
  }
}
export function getClassNameByIndice(Indice: any): string {
  if (Indice > 2) {
    return "dobleIndice";
  }
  return "";
}
export function handleValueDataEmpytAudienceIndice(
  valueData: string,
  sufix: string
) {
  if (valueData === "-") return valueData;

  return valueData + sufix;
}

export function handleValueDataAudienceIndice(
  valueData: string,
  sufix: string
) {
  let resultValue = "";
  if (valueData !== null && valueData !== undefined) {
    if (valueData === "-") return valueData;
    resultValue = valueData;
    const valueIsDoubleIndice = resultValue.indexOf("|") >= 0;
    resultValue = AdjustValueDataAudienceIndiceNaNOrInfinity(valueData);
    resultValue = AdjustValueDataAudienceIndiceNotNaNOrInfinity(
      resultValue,
      sufix,
      valueIsDoubleIndice
    );
    resultValue = AdjustValueDataAudienceIndiceDoubleEmpyt(
      resultValue,
      valueIsDoubleIndice
    );
  }
  resultValue = resultValue === "Infinity" ? "∞" : resultValue;
  return resultValue;
}
export function AdjustValueDataAudienceIndiceNaNOrInfinity(valueData) {
  let resultValue = valueData;
  if (resultValue.indexOf("NaN") >= 0 || resultValue.indexOf("Infinity") >= 0) {
    resultValue = resultValue.replace("%", "");
  }
  return resultValue;
}
export function AdjustValueDataAudienceIndiceNotNaNOrInfinity(
  valueData,
  sufix: string,
  valueIsDoubleIndice: boolean
) {
  let resultValue = valueData;
  if (
    resultValue !== "NaN" &&
    resultValue !== "Infinity" &&
    resultValue !== " " &&
    !valueIsDoubleIndice
  ) {
    resultValue += sufix;
  }
  return resultValue;
}

export function AdjustValueDataAudienceIndiceDoubleEmpyt(
  valueData,
  valueIsDoubleIndice: boolean
) {
  let resultValue = valueData;
  if (valueIsDoubleIndice) {
    const splitVal = valueData.split("|");
    if (
      (splitVal[0].trim() === "" && splitVal[1].trim() === "") ||
      resultValue === "-|-"
    ) {
      resultValue = "";
    }
  }
  return resultValue;
}
